import React, { useState, useEffect, useCallback } from 'react';
import ScGrid from '../ScGrid';
import ScModal from '../ScModal';
import ScSpinner from '../ScSpinner';
import { fetchEmailFormats, createEmailFormat, updateEmailFormat } from '../../studyConfigurationApi';

const DEFAULT_EMAIL_FORMAT_NAME = 'General';

const emptyForm = () => ({
  emailFormat: DEFAULT_EMAIL_FORMAT_NAME,
  emailHeader: '',
  emailBody: '',
  emailFooter: '',
});

const EmailFormatsTab = () => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [form, setForm] = useState(emptyForm());
  const [editId, setEditId] = useState(null);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const res = await fetchEmailFormats();
      setRows(res.data || []);
    } catch (e) {
      setError(e.response?.data?.error || 'Failed to load email formats.');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  const save = async () => {
    try {
      if (editId) await updateEmailFormat(editId, { ...form, emailFormatMstNo: editId });
      else await createEmailFormat({ ...form, emailFormat: DEFAULT_EMAIL_FORMAT_NAME });
      setModalOpen(false);
      load();
    } catch (e) {
      setError(e.response?.data?.error || 'Save failed.');
    }
  };

  if (loading) return <ScSpinner />;
  return (
    <div>
      {error && <div className="sc-alert sc-alert-error">{error}</div>}
      <div className="sc-toolbar">
        <button type="button" className="sc-btn sc-btn-primary" onClick={() => { setEditId(null); setForm(emptyForm()); setModalOpen(true); }}>Add Format</button>
      </div>
      <ScGrid
        columns={[{ key: 'emailFormat', label: 'Format' }]}
        rows={rows}
        onEdit={(r) => { setEditId(r.emailFormatMstNo); setForm({ emailFormat: r.emailFormat, emailHeader: r.emailHeader, emailBody: r.emailBody, emailFooter: r.emailFooter }); setModalOpen(true); }}
      />
      <ScModal open={modalOpen} title={editId ? 'Edit Format' : 'Add Format'} onClose={() => setModalOpen(false)}
        footer={<><button type="button" className="sc-btn sc-btn-secondary" onClick={() => setModalOpen(false)}>Cancel</button><button type="button" className="sc-btn sc-btn-primary" onClick={save}>Save</button></>}>
        <div className="sc-form-row">
          <label>Name</label>
          <input
            value={editId ? form.emailFormat : DEFAULT_EMAIL_FORMAT_NAME}
            disabled={!editId}
            onChange={(e) => setForm({ ...form, emailFormat: e.target.value })}
          />
        </div>
        <div className="sc-form-row"><label>Header</label><textarea value={form.emailHeader || ''} onChange={(e) => setForm({ ...form, emailHeader: e.target.value })} /></div>
        <div className="sc-form-row"><label>Body</label><textarea value={form.emailBody || ''} onChange={(e) => setForm({ ...form, emailBody: e.target.value })} /></div>
        <div className="sc-form-row"><label>Footer</label><textarea value={form.emailFooter || ''} onChange={(e) => setForm({ ...form, emailFooter: e.target.value })} /></div>
      </ScModal>
    </div>
  );
};

export default EmailFormatsTab;
